import { CommissionContract } from "../../../api/ComissionContractsAPI";
import { CommissionContractOfferDto } from "../../../api/CommissionContractOffersAPI";
import BrideTabSection from "./BrideTabSection";
import OrderTabSection from "./OrderTabSection";

interface GeneralTabSectionProps {
  form: CommissionContract;
  commission: CommissionContract;
  isEditing: boolean;
  offerDisplayName?: string;
  enabledOffers?: CommissionContractOfferDto[];
  showOfferChangeHint?: boolean;
  showPdfNotice: boolean;
  onInputChange: (field: keyof CommissionContract) => (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  onPhoneChange: (value: string) => void;
  onEndDateChange: (date: Date | null) => void;
  onSelectOffer?: (offerId: number) => void;
}

export default function GeneralTabSection({
  form,
  commission,
  isEditing,
  offerDisplayName,
  enabledOffers,
  showOfferChangeHint,
  showPdfNotice,
  onInputChange,
  onPhoneChange,
  onEndDateChange,
  onSelectOffer,
}: GeneralTabSectionProps) {
  return (
    <div className="space-y-6">
      <BrideTabSection
        form={form}
        commission={commission}
        isEditing={isEditing}
        onInputChange={onInputChange}
        onPhoneChange={onPhoneChange}
      />
      <OrderTabSection
        form={form}
        commission={commission}
        isEditing={isEditing}
        offerDisplayName={offerDisplayName}
        enabledOffers={enabledOffers}
        showOfferChangeHint={showOfferChangeHint}
        showPdfNotice={showPdfNotice}
        onInputChange={onInputChange}
        onEndDateChange={onEndDateChange}
        onSelectOffer={onSelectOffer}
      />
    </div>
  );
}
